import {isEven, isOdd, twMerge} from '@sdox/utils'

import {Quote} from './Quote'

import type {ClassNameValue} from 'tailwind-merge'
import type {QuoteProps} from './Quote'

export interface QuoteColsProps {
  className?: ClassNameValue
  items?: QuoteProps[]
}

const QuoteCol = ({items}: Pick<QuoteColsProps, 'items'>) => (
  <div className={'flex flex-col gap-block-small'}>
    {items?.map(({text}, i) => (
      <Quote
        key={i}
        text={text}
      />
    ))}
  </div>
)

export const QuoteCols = ({className, items = []}: QuoteColsProps) => {
  if (items?.length < 1) return null
  if (items?.length === 1) return <Quote text={items[0].text} />

  const col1 = items.filter((_, i) => isEven(i))
  const col2 = items.filter((_, i) => isOdd(i))

  return (
    <div className={twMerge('grid gap-block-small @block-medium:grid-cols-2', className)}>
      <QuoteCol items={col1} />
      <QuoteCol items={col2} />
    </div>
  )
}
